import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import { Form as FinalForm } from 'react-final-form';
import { toast } from 'react-toastify';
import { parse} from '../../util/urlHelpers';
import { createResourceLocatorString } from '../../util/routes';

import { intlShape, injectIntl } from '../../util/reactIntl';
import {
  Button,
  FieldTextInput,
  Form,
  PaginationLinks,
} from '../../components';
import { FormSpy } from 'react-final-form';

import css from './TrackUserForm.module.css';
import ContentLoader from 'react-content-loader';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';


const TrackUserFormComponent = props => {
  const {
    rootClassName,
    className,
    handleSubmit,
    trackUsers,
    trackUsersInProgress,
    handleShowReport,
    onfetchtrackUser,
    selectedRole,
    setSelectedRole,
    guestsUser,
    history,
    onfetchGuestsUser,
    guestsUsersInProgress,
    location,
  } = props;

  const classes = classNames(rootClassName, className);
  const data = selectedRole === "AuthenticatedUsers" ?  trackUsers?.data  : guestsUser?.data || [];
  const pagination = selectedRole === "AuthenticatedUsers" ?  trackUsers?.pagination : guestsUser?.pagination || {};

  const [searchEmail, setSearchEmail] = useState('');
  const [lastSubmittedEmail, setLastSubmittedEmail] = useState('');

  const routeConfiguration = useRouteConfiguration();

  useEffect(() => {
    const urlParams = parse(location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });
    const email = urlParams.email || '';
    setSearchEmail(email);
    setLastSubmittedEmail(email);
  }, [location.search]);

  const handleFormSubmit = values => {
    const email = values.email ? values.email.trim() : '';

    if (!email) {
      toast.error('Please enter an email to search');
      return;
    }

    setSearchEmail(email);
    setLastSubmittedEmail(email);

    const currentParams = parse(location.search);
    const newParams = { ...currentParams, page: 1, email };

    const newPath = createResourceLocatorString('TrackUserPage', routeConfiguration, {}, newParams);

    history.push(newPath);
    // Data fetching is handled by useEffect in TrackUserPage when location.search changes
  };

  const handleEmailChange = (form, values) => {
    const email = values?.email ? values.email.trim() : '';
    // When user clears the email field and there was a previous search, reset to show all users
    if (!email && lastSubmittedEmail) {
      setSearchEmail('');
      setLastSubmittedEmail('');

      const currentParams = parse(location.search);
      const newParams = { ...currentParams, page: 1 };
      delete newParams.email;

      const newPath = createResourceLocatorString('TrackUserPage', routeConfiguration, {}, newParams);
      history.push(newPath);
      // Data fetching is handled by useEffect in TrackUserPage when location.search changes
    }
  };

  const handleTabSwitch = (newRole) => {
    if (newRole === selectedRole) {
      return;
    }
    setSelectedRole(newRole);
    const currentParams = parse(window.location.search, {
      latlng: ['origin'],
      latlngBounds: ['bounds'],
    });

    const newParams = {
      ...currentParams,
      page: 1,
    };

    if (newRole === 'guests') {
      delete newParams.email;
    }

    const newPath = createResourceLocatorString(
      'TrackUserPage',
      routeConfiguration,
      {},
      newParams
    );

    history.push(newPath);
    // Data fetching is handled by useEffect in TrackUserPage when location.search or selectedRole changes
  };
  const MyLoader = () => (
    <ContentLoader height={220} width={800}>
      <rect x="0" y="0" rx="4" ry="4" width="800" height="20" />
      <rect x="0" y="30" rx="4" ry="4" width="800" height="20" />
      <rect x="0" y="60" rx="4" ry="4" width="800" height="20" />
      <rect x="0" y="90" rx="4" ry="4" width="800" height="20" />
      <rect x="0" y="120" rx="4" ry="4" width="800" height="20" />
      <rect x="0" y="150" rx="4" ry="4" width="800" height="20" />
    </ContentLoader>
  );

  return (
    <FinalForm
      key={searchEmail}
      onSubmit={handleFormSubmit}
      initialValues={{ email: searchEmail }}
      render={({ handleSubmit, form }) => (
        <Form className={classes} onSubmit={handleSubmit}>
          <FormSpy subscription={{ values: true }}>
            {({ values }) => {
              handleEmailChange(form, values);
              return null;
            }}
          </FormSpy>
          {(selectedRole === "AuthenticatedUsers" ? trackUsersInProgress : guestsUsersInProgress) ? (
            <MyLoader />
          ) : (
            <>
              <div className={css.searchInput}>
                <FieldTextInput
                  id="TrackUserPage.Search"
                  className={css.emailInput}
                  name="email"
                  type="text"
                  placeholder="Enter any email"
                />

                <Button type="submit" className={css.searchButton}>
                  Search
                </Button>
              </div>

              {/* tabs for authenticated and unauthenticated users */}
                <div className={css.roleToggle}>
                  <button
                    type="button"
                    className={selectedRole === "AuthenticatedUsers" ? css.activeRoleBtn : ""}
                    onClick={() => handleTabSwitch("AuthenticatedUsers")}
                  >
                    Authenticated Users
                  </button>
                  <button
                    type="button"
                    className={selectedRole === "guests" ? css.activeRoleBtn : ""}
                    onClick={() => handleTabSwitch("guests")}
                  >
                    Guests
                  </button>
                </div>

                {
                  selectedRole === "AuthenticatedUsers"
                    ? <div className={css.tableContainer}>
                      <table className={css.transactionTable}>
                        <thead>
                          <tr>
                            <th>Serial No.</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Account Type</th>
                            <th>UserId</th>
                            <th>View Report</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.length === 0 ? (
                            <tr>
                              <td colSpan="6" style={{ textAlign: 'center' }}>
                                No users found
                              </td>
                            </tr>
                          ) : (
                            data &&
                            data?.length &&
                            data?.map((user, index) => (
                              <tr key={user._id}>
                                <td>
                                  {(pagination?.page - 1) * pagination?.perPage +
                                    index +
                                    1}
                                </td>
                                <td>{user?.attributes?.profile?.displayName}</td>
                                <td className={css.email}>{user?.attributes?.email}</td>
                                <td className={css.email}>
                                  {user?.attributes?.profile?.publicData?.accountType}
                                </td>
                                <td className={css.debit}>{user?.id?.uuid}</td>
                                <td onClick={() => handleShowReport({userId:user?.id?.uuid})}>
                                  Report
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    : <div className={css.tableContainer}>
                      <table className={css.transactionTable}>
                        <thead>
                          <tr>
                            <th>Serial No.</th>
                            <th>deviceId</th>
                            <th>View Report</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.length === 0 ? (
                            <tr>
                              <td colSpan="6" style={{ textAlign: 'center' }}>
                                No users found
                              </td>
                            </tr>
                          ) : (
                            data &&
                            data?.length &&
                            data?.map((user, index) => (
                              <tr key={user._id}>
                                <td>
                                  {(pagination?.page - 1) * pagination?.perPage +
                                    index +
                                    1}
                                </td>
                                
                                <td className={css.debit}>{user?.deviceId}</td>
                                <td onClick={() => handleShowReport({deviceId:user?.deviceId})}>
                                  Report
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                }

              <PaginationLinks
                className={css.pagination}
                pageName="TrackUserPage"
                pagePathParams={{}}
                pageSearchParams={{ 
                  page: pagination.page, 
                  ...(searchEmail.trim() && { email: searchEmail.trim() })
                }}
                pagination={pagination}
              />
            </>
          )}
        </Form>
      )}
    />
  );
};

TrackUserFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  desktopInputRoot: null,
  isMobile: false,
};

export default injectIntl(TrackUserFormComponent);
